<template>
  <div class="container">
    <el-row class="row" :gutter="17">
      <el-col class="col" :span="8">
        <el-card class="el-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>用工管理</span>
          </div>
          <div class="endance">
            <div class="endance-item">
              <div class="endance-item-top">
                <span class="top-s1">用工总量</span>
                <div class="top-item">
                  <span class="top-s2">{{ signNum ?? "--" }}</span>
                  <span class="top-s3"> 人次</span>
                </div>
              </div>
              <div class="endance-item-bottom">
                <div class="bottom-item">
                  <div class="item-img">
                    <div class="item-img-i">
                      <i class="el-icon-s-custom"></i>
                    </div>
                  </div>
                  <div class="item-1">
                    <span class="endance-s1">实名工人</span>
                    <div class="item-2">
                      <span class="endance-s2">{{ onSignNum ?? "--" }}</span>
                      <span class="endance-s3"> 人次</span>
                    </div>
                  </div>
                </div>
                <div class="bottom-item">
                  <div class="item-img">
                    <div class="item-img-i">
                      <i class="el-icon-s-custom i1"></i>
                      <i class="el-icon-s-custom i2"></i>
                    </div>
                  </div>
                  <div class="item-1">
                    <span class="endance-s1">劳务班组</span>
                    <div class="item-2">
                      <span class="endance-s2"> {{ offSignNum ?? "--" }}</span>
                      <span class="endance-s3"> 人次</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="endance-content" ref="endanceBar" id="endanceBar"></div>
          </div>
        </el-card>
      </el-col>
      <el-col class="col" :span="7">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>养护日报</span>
          </div>
          <div class="dailyreport-content" id="dailyreport" ref="dailyreport"></div>
        </el-card>
      </el-col>
      <el-col class="col" :span="9">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>养护工单</span>
          </div>
          <div class="task">
            <div class="task-content">
              <div class="task-pie" ref="workOrder" id="workOrder"></div>
              <div class="task-item">
                <div class="task-top">
                  <span class="task-s1">工单总数：</span>
                  <span class="task-s1">已 完 成：</span>
                  <span class="task-s1">未 完 成：</span>
                </div>
                <div class="task-bottom">
                  <span class="task-s2">{{ workCount ?? "--" }}</span>
                  <span class="task-s2">{{ doneNum ?? "--" }}</span>
                  <span class="task-s2">{{ doingNum ?? "--" }}</span>
                </div>
              </div>
            </div>
            <div class="issues-content" ref="issues" id="issues"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="height: 10px"></el-row>
    <el-row class="row" :gutter="15">
      <el-col class="col" :span="9">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>品质监管</span>
          </div>
          <div class="patrol">
            <div class="patrol-item">
              <div class="patrol-left">
                <div class="patrol-left-item" :class="{ active: Tabs === '0' ? 'active' : '' }"
                  @click="changeTabs('0')">
                  <div class="line" :class="{ active: Tabs === '0' ? 'active' : '' }"></div>
                  <div class="patrol-left-item-d">
                    <span class="patrol-left-item-s1">巡查任务</span>
                    <span class="patrol-left-item-s2">{{
                      taskCount ?? "--"
                    }}</span>
                    <span class="patrol-left-item-s3">已完成：{{ ywcTaskCount ?? "--" }}</span>
                    <span class="patrol-left-item-s3">未完成：{{ wwcTaskCount ?? "--" }}</span>
                  </div>
                </div>
                <div class="patrol-left-item" :class="{ active: Tabs === '1' ? 'active' : '' }"
                  @click="changeTabs('1')">
                  <div class="line" :class="{ active: Tabs === '1' ? 'active' : '' }"></div>
                  <div class="patrol-left-item-d">
                    <span class="patrol-left-item-s1">巡查问题</span>
                    <span class="patrol-left-item-s2">{{
                      issueCount ?? "--"
                    }}</span>
                    <span class="patrol-left-item-s3">已完成：{{ yclIssueCount ?? "--" }}</span>
                    <span class="patrol-left-item-s3">未完成：{{ dclIssueCount ?? "--" }}</span>
                  </div>
                </div>
              </div>
              <div class="patrol-right" :class="{ show: showTask ? 'show' : '' }"
                v-if="Tabs === '0' && showTask === false" ref="taskBar" id="taskBar"></div>
              <div class="patrol-right1" v-if="Tabs === '0' && showTask === true">
                <el-empty :image-size="200"></el-empty>
              </div>
              <div class="patrol-right" v-if="Tabs === '1' && showTask === false" ref="issuesBar" id="issuesBar"></div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col class="col" :span="5">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>用料管理</span>
          </div>
          <div class="material-content" id="materialNightingale" ref="materialNightingale"></div>
        </el-card>
      </el-col>
      <el-col class="col" :span="5">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>机械管理</span>
          </div>
          <div class="machine-content" id="machinePie" ref="machinePie"></div>
          <div class="machineMage">
            <div class="machineMage-item">
              <span class="machineMage-item-s1">机械数量</span>
              <span class="machineMage-item-s2">
                {{ machineCount ? machineCount : 0 }}
              </span>
            </div>
            <div class="machineMage-item">
              <span class="machineMage-item-s1">台班/小时数</span>
              <span class="machineMage-item-s2">
                {{ machineHour ? machineHour : 0 }}
              </span>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col class="col" :span="5">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>智能设备</span>
          </div>
          <div class="item" @click="showDialog">
            <div class="device-content" id="deviceGauge" ref="deviceGauge"></div>
            <div class="devicecount">
              <div class="devicecount-item">
                <span class="devicecount-item-s1">设备总数</span>
                <span class="devicecount-item-s2">{{
                  deviceTotal ? deviceTotal : 0
                }}</span>
              </div>
              <div class="devicecount-item">
                <span class="devicecount-item-s1">在线设备</span>
                <span class="devicecount-item-s2">{{
                  totalOnline ? totalOnline : 0
                }}</span>
              </div>
              <div class="devicecount-item">
                <span class="devicecount-item-s1">离线设备</span>
                <span class="devicecount-item-s2">{{
                  totalOffline ? totalOffline : 0
                }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <deviceDialog :dialogVisible.sync="dialogVisible" :projectId="projectId"></deviceDialog>
  </div>
</template>

<script>
import deviceDialog from "./deviceDialog.vue";
import chartMixin from "@/mixins/mixin";
export default {
  mixins: [chartMixin],
  name: "Board",
  components: {
    deviceDialog,
  },
  data() {
    return {
      projectId: "",
      Tabs: "0",
      searchdate: [],
      dialogVisible: false,
      deviceList: [],
      deviceTotal: 0, // 设备总数
      totalOnline: 0, // 在线设备
      totalOffline: 0, // 离线设备
      onlineRate: "", // 在线率
      machineCount: 0, // 机械数量
      machineHour: 0, // 台班/小时数
      offSignNum: 0, // 劳务班组
      onSignNum: 0, // 实名工人
      signNum: 0, // 用工总量
      wwcTaskCount: 0, // 未完成巡查任务
      ywcTaskCount: 0, // 已完成巡查任务
      taskCount: 0, // 巡查任务数量
      yclIssueCount: 0, // 已处理巡查问题
      dclIssueCount: 0, // 未处理巡查问题
      issueCount: 0, // 巡查问题数量
      workCount: 0, // 工单总数
      doingNum: 0, // 未完成
      doneNum: 0, // 已完成
      workOrderRate: "", // 工单完成率
      showTask: false, // 显示任务
      issuesBar: null, // 问题
    };
  },
  computed: {
    projectList() {
      return this.$store.state.projectList;
    },
  },
  watch: {
    // 监听项目切换
    projectId(newVal, oldVal) {
      if (newVal === oldVal) return;
      // 用工
      this.getEndanceCount();
      // 日报
      this.getDailyReport();
      // 工单
      this.getWorkOrder();
      // 监管
      this.getTaskBar();
      this.getIssuesBar();
      // 用料
      this.getMaterial();
      // 机械
      this.getMachine();
      // 设备
      this.getDeviceOnlineTotal();
    },
    // 监听时间切换
    searchdate(newVal, oldVal) {
      if (newVal === oldVal) return;
      // 用工
      this.getEndanceCount();
      // 日报
      this.getDailyReport();
      // 工单
      this.getWorkOrder();
      // 监管
      this.getTaskBar();
      this.getIssuesBar();
      // 用料
      this.getMaterial();
      // 机械
      this.getMachine();
    },
  },
  created() {
    this.setDefaultMonth();

    // // do something
    this.$event.$on("onBoardProjectChange", (val) => {
      this.projectId = val;
    });
    this.$event.$on("onBoardMothenChange", (val) => {
      this.searchdate = val;
    });
    if (this.$route.query.projectId) {
      this.projectId = this.$route.query.projectId;
      this.searchdate = [
        this.$route.query.startTime,
        this.$route.query.endTime,
      ];
      this.$router.replace({
        path: this.$route.path,
        query: {},
      });
    }

    // 初始化
    // 用工
    this.getEndanceCount();
    // 日报
    this.getDailyReport();
    // 工单
    this.getWorkOrder();
    // 监管
    this.getTaskBar();
    this.getIssuesBar();
    // 用料
    this.getMaterial();
    // 机械
    this.getMachine();
    // 设备
    this.getDeviceOnlineTotal();
  },
  mounted() {
    window.onerror = (message, source, lineno, colno, error) => {
      if (message.includes("getAttribute")) {
        return true; // 抑制特定错误
      }
    };
  },
  methods: {
    // 获取用工管理数据
    Tostatistics() {
      this.$disposeCharts()
      const projectId = this.projectId || "";
      const yearMonth = this.searchdate[0]
        ? this.searchdate[0].slice(0, 7)
        : "";
      this.$router.push({
        name: "statistics",
        query: { yearMonth, projectId },
      });
    },
    getEndanceCount() {
      this.$axios
        .get(this.$apis.statement.selectYhAttendanceCountV2, {
          projectId: this.projectId,
          startTime: this.searchdate[0] ? this.searchdate[0] : "",
          endTime: this.searchdate[1] ? this.searchdate[1] : "",
        })
        .then((res) => {
          this.offSignNum = res.offSignNum; // 劳务班组
          this.onSignNum = res.onSignNum; // 实名工人
          this.signNum = res.signNum; // 用工总量
          let barType = "";
          let itemStyle = {};
          if (this.projectId === "") {
            barType = "bar";
            itemStyle = {
              color: "#895BF1",
              barBorderRadius: [10],
            };
          } else {
            barType = "line";
            itemStyle = {
              color: "#F373AE",
            };
          }

          this.$nextTick(() => {
            const endanceBar = this.$getChartInstance("#endanceBar");
            if (!endanceBar) return;
            const xdata = res.list.map((item) => {
              return item.day;
            });
            const ydata = res.list.map((item) => {
              return item.signNum;
            });
            const maxValue = Math.max(...ydata);
            const option = {
              grid: {
                left: 20,
                top: 60,
                right: 14,
                bottom: 20,
                containLabel: true,
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
                extraCssText: "text-align: left;",
                confine: true,
                renderMode: "html",
                appendToBody: true,
                textStyle: {
                  textAlign: "left",
                },
              },
              xAxis: {
                type: "category",
                data: xdata || [],
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  overflow: "truncate",
                  ellipsis: "...",
                  color: "#809FB8",
                  fontSize: 12,
                  fontFamily: "PingFangSC, PingFang SC",
                  fontWeight: "400",
                  fontStyle: "normal",
                  textTransform: "none",
                  formatter: function (value) {
                    if (value.length > 5) {
                      return value.slice(0, 4);
                    } else {
                      return value;
                    }
                  },
                },
              },
              yAxis: {
                type: "value",
                axisLabel: {
                  show: false,
                },
              },
              dataZoom: [
                {
                  type: "slider", // 内置缩放
                  show: xdata.length > 7, // 是否显示
                  xAxisIndex: [0], // 应用到的 x 轴
                  start: 0, // 初始缩放比例
                  end: xdata.length > 7 ? 20 : 100, // 结束缩放比例
                  filterMode: "empty",
                  height: 5, // 组件高度
                  bottom: 0, // 组件距离底部的距离
                  borderColor: "transparen", // 边框颜色
                  handleSize: 10, // 手柄大小
                  zoomLock: true, // 缩放锁定
                  showDetail: false, // 不显示详细信息
                  showDataShadow: false,
                  brushSelect: false,
                  handleStyle: {
                    opacity: 0.3,
                  },
                  backgroundColor: "#eee",
                  fillerColor: "#895BF1",
                },
              ],
              series: [
                {
                  data: ydata || [],
                  type: barType,
                  itemStyle: itemStyle,
                  barWidth: 14,
                  barMaxWidth: 20,
                  smooth: true,
                  silent: false,
                  symbol: (val) =>
                    val === maxValue && maxValue ? "emptyCircle" : "none",
                  symbolSize: 15,
                  areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "rgba(243, 115, 174, 0.8)",
                      },
                      {
                        offset: 1,
                        color: "rgba(243, 115, 174, 0)",
                      },
                    ]),
                  },
                },
              ],
            };
            endanceBar.setOption(option);
            endanceBar.getZr().off("click");
            if (this.projectId === "") {
              endanceBar.getZr().on("click", (params) => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (endanceBar.containPixel("grid", pointInPixel)) {
                  let yIndex = endanceBar.convertFromPixel({ seriesIndex: 0 }, [
                    params.offsetX,
                    params.offsetY,
                  ])[0];
                  const xValue = xdata[yIndex]; //x轴的值
                  endanceBar.dispatchAction({ type: "hideTip" });
                  const yearMonth = this.searchdate[0]
                    ? this.searchdate[0].slice(0, 7)
                    : "";
                  this.projectId = this.projectList.filter(
                    (item) => item.projectName === xValue
                  )[0].projectId;
                  this.$router.push({
                    name: "statistics",
                    query: { yearMonth, projectId: this.projectId },
                  });
                }
              });
            } else {
              endanceBar.getZr().on("click", () => {
                endanceBar.dispatchAction({ type: "hideTip" });
                this.Tostatistics();
              });
            }
          });
        });
    },
    // 获取养护日报
    setDefaultMonth() {
      const today = new Date();
      // 本月第一天
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      start.setHours(0, 0, 0, 0);
      // 本月最后一天
      const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      end.setHours(23, 59, 59, 999);

      // 格式化为 YYYY-MM-DD
      const format = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 补零
        const day = String(date.getDate()).padStart(2, "0"); // 补零
        return `${year}-${month}-${day}`;
      };
      this.searchdate = [format(start), format(end)];
    },
    getDailyReport() {
      const params = {
        projectId: this.projectId,
        startTime: this.searchdate[0] ? this.searchdate[0] : "",
        endTime: this.searchdate[1] ? this.searchdate[1] : "",
      };
      this.$axios
        .get(this.$apis.workPlan.selectProjectDailySumV2, params)
        .then((res) => {
          this.$nextTick(() => {
            if (this.projectId === "") {
              const dailyreport = this.$getChartInstance("#dailyreport");
              if (!dailyreport) return;
              const yData = res.map((item) => {
                return item.x;
              });
              const xData = res.map((item) => {
                return item.recordRate;
              });
              const maxValue = Math.max(...xData);
              const option = {
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "shadow",
                  },
                  appendToBody: true,
                  formatter: function (params) {
                    let str = "";
                    params.forEach((item) => {
                      // 添加颜色小点
                      str += `<div style="color: #333; font-size: 14px;">${item.name}</div>
                    `;
                      str += `<div style="display: flex; align-items: center;">
                    <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background-color: ${item.color}; margin-right: 5px;"></span>
                    <div style="color: #333; font-size: 14px; margin-left: 15px;">${item.data}%</div>
                    </div>`;
                    });
                    return str;
                  },
                },
                grid: {
                  left: 24,
                  top: 20,
                  right: 30,
                  bottom: 30,
                  containLabel: true,
                },
                xAxis: {
                  type: "value",
                  min: 0,
                  max: maxValue < 100 ? null : 100,
                  minorSplitLine: {
                    lineStyle: {
                      color: "#eee",
                    },
                  },
                  axisLabel: {
                    color: "#809FB8",
                    fontSize: 12,
                    fontFamily: "PingFangSC, PingFang SC",
                    fontWeight: "400",
                    fontStyle: "normal",
                    textTransform: "none",
                    formatter: function (value) {
                      return value + "%"; // 转换为百分比显示
                    },
                  },
                  tooltip: {
                    show: true,
                  },
                },
                yAxis: {
                  type: "category",
                  data: yData.reverse(),
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    overflow: "truncate",
                    ellipsis: "...",
                    color: "#809FB8",
                    fontSize: 12,
                    fontFamily: "PingFangSC, PingFang SC",
                    fontWeight: "400",
                    fontStyle: "normal",
                    textTransform: "none",
                    formatter: function (value) {
                      if (value.length > 5) {
                        return value.slice(0, 4);
                      } else {
                        return value;
                      }
                    },
                  },
                },
                dataZoom: [
                  {
                    id: "dataZoomY",
                    type: "slider",
                    yAxisIndex: [0],
                    start: xData.length > 7 ? 80 : 0,
                    end: 100,
                    filterMode: "filter",
                    show: xData.length > 7, // 是否显示,
                    width: 5, // 组件宽度
                    left: 0,
                    borderColor: "transparen", // 边框颜色
                    handleSize: 10, // 手柄大小
                    zoomLock: true, // 缩放锁定
                    showDetail: false, // 不显示详细信息
                    showDataShadow: false,
                    brushSelect: false,
                    handleStyle: {
                      opacity: 0.3,
                    },
                    backgroundColor: "#eee",
                    fillerColor: "#0090FF ",
                  },
                ],
                series: [
                  {
                    data: xData.reverse(),
                    type: "bar",
                    showBackground: true,
                    backgroundStyle: {
                      borderRadius: [8],
                      color: "#eee",
                    },
                    barMaxWidth: 14,
                    barGap: 20,
                    animationDurationUpdate: 0,
                    itemStyle: {
                      color: "#0090FF",
                      barBorderRadius: [7],
                    },
                  },
                ],
              };
              dailyreport.setOption(option);
              dailyreport.getZr().off("click");
              dailyreport.getZr().on("click", (params) => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (dailyreport.containPixel("grid", pointInPixel)) {
                  let xIndex = dailyreport.convertFromPixel(
                    { seriesIndex: 0 },
                    [params.offsetX, params.offsetY]
                  )[1];
                  const yValue = yData[xIndex]; //y轴的值
                  dailyreport.dispatchAction({ type: "hideTip" });
                  const startTime = this.searchdate[0]
                    ? this.searchdate[0]
                    : "";
                  const endTime = this.searchdate[1] ? this.searchdate[1] : "";
                  this.projectId = this.projectList.filter(
                    (item) => item.projectName === yValue
                  )[0].projectId;
                  this.$router.push({
                    name: "maintenanceDaily",
                    query: { projectId: this.projectId, startTime, endTime },
                  });
                }
              });
            } else {
              const dailyreport = this.$getChartInstance("#dailyreport");
              if (!dailyreport) return;
              const ytbRecord = res[0].ytbRecord;
              const wtbRecord = res[0].wtbRecord;
              const option = {
                grid: {
                  top: 20,
                  bottom: 10,
                  left: 10,
                  right: 10,
                },
                tooltip: {
                  trigger: "item",
                },
                legend: {
                  left: "center",
                },
                series: [
                  {
                    type: "pie",
                    radius: "80%",
                    startAngle: 0,
                    endAngle: "auto",
                    top: 20,
                    data: [
                      {
                        value: ytbRecord,
                        name: "已提交",
                        itemStyle: {
                          color: "rgb(104,187,196)",
                          borderCap: "round",
                        },
                      },
                      {
                        value: wtbRecord,
                        name: "未提交",
                        itemStyle: {
                          color: "rgb(80,135,236)",
                          borderCap: "round",
                        },
                      },
                    ],
                    emphasis: {
                      itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                      },
                    },
                  },
                ],
              };
              dailyreport.setOption(option);
              dailyreport.getZr().off("click");
              dailyreport.getZr().on("click", () => {
                dailyreport.dispatchAction({ type: "hideTip" });
                this.ToMaintenanceDay();
              });
            }
          });
        });
    },
    ToMaintenanceDay() {
      this.$disposeCharts()
      const projectId = this.projectId || "";
      const startTime = this.searchdate[0] ? this.searchdate[0] : "";
      const endTime = this.searchdate[1] ? this.searchdate[1] : "";
      this.$router.push({
        name: "maintenanceDaily",
        query: { projectId, startTime, endTime },
      });
    },
    // 获取养护工单
    getWorkOrder() {
      this.$axios
        .get(this.$apis.workPlan.selectLcWorkOrderByCountV2, {
          projectId: this.projectId,
          startTime: this.searchdate[0] ? this.searchdate[0] : "",
          endTime: this.searchdate[1] ? this.searchdate[1] : "",
        })
        .then((res) => {
          this.workCount = res.total; // 工单总数
          this.doingNum = res.doingNum; // 未完成
          this.doneNum = res.doneNum; // 已完成
          this.workOrderRate = res.rate; // 工单完成率
          this.$nextTick(() => {
            const workOrder = this.$getChartInstance("#workOrder");
            const issues = this.$getChartInstance("#issues");
            if (!workOrder) return;
            if (!issues) return;
            const workDoneNum = res.list.map((item) => {
              return item.doneNum;
            });
            const workDoingNum = res.list.map((item) => {
              return item.doingNum;
            });
            const xAxis = res.list.map((item) => {
              return item.x;
            });
            const option1 = {
              series: [
                {
                  type: "gauge",
                  startAngle: 90,
                  endAngle: -270,
                  center: ["50%", "50%"],
                  radius: "90%",
                  pointer: {
                    show: false,
                  },
                  progress: {
                    show: true,
                    overlap: false,
                    roundCap: false,
                    clip: false,
                  },
                  axisLine: {
                    lineStyle: {
                      width: 14,
                      color: [[1, "#F1F1F1"]],
                    },
                  },
                  splitLine: {
                    show: false,
                    distance: 0,
                    length: 10,
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    show: false,
                    distance: 5,
                  },
                  data: [
                    {
                      value: this.workOrderRate,
                      name: "完成率",
                      itemStyle: {
                        color: "#7ED321",
                        emphasis: {
                          opacity: 1,
                        },
                      },
                      title: {
                        offsetCenter: ["-2%", "26%"],
                      },
                      detail: {
                        offsetCenter: ["0%", "-10%"],
                      },
                    },
                  ],
                  title: {
                    fontSize: 12,
                    color: "#354052",
                    width: 50,
                    height: 28,
                    fontFamily: "PingFangSC, PingFang SC",
                    fontWeight: "600",
                  },
                  detail: {
                    width: 50,
                    height: 28,
                    fontSize: 18,
                    color: "#354052",
                    fontFamily: "PingFangSC, PingFang SC",
                    fontWeight: "600",
                    formatter: "{value}%",
                  },
                },
              ],
            };
            const option2 = {
              legend: {
                data: ["已完成", "未完成"],
                right: 15,
                top: 20,
                itemWidth: 12,
                itemHeight: 12,
                textStyle: {
                  fontSize: 12,
                  color: "#809FB8",
                  fontFamily: "PingFangSC, PingFang SC",
                  fontWeight: "400",
                  fontStyle: "normal",
                  textTransform: "none",
                },
              },
              grid: {
                left: 10,
                top: 60,
                right: 14,
                bottom: 13,
                containLabel: true,
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              xAxis: {
                type: "category",
                data: xAxis,
                axisTick: {
                  show: false,
                },
                barMaxWidth: 20,
                axisLine: {
                  show: false,
                },
                axisLabel: {
                  overflow: "truncate",
                  ellipsis: "...",
                  color: "#809FB8",
                  fontSize: 12,
                  fontFamily: "PingFangSC, PingFang SC",
                  fontWeight: "400",
                  fontStyle: "normal",
                  textTransform: "none",
                  formatter: function (value) {
                    return value.slice(0, 5);
                  },
                },
              },
              yAxis: {
                type: "value",
                axisLabel: {
                  show: false,
                },
              },
              dataZoom: [
                {
                  type: "slider", // 内置缩放
                  xAxisIndex: [0],
                  start: 0, // 初始缩放比例
                  end: xAxis.length > 7 ? 20 : 100, // 结束缩放比例
                  filterMode: "empty",
                  height: 5, // 组件高度
                  bottom: 5,
                  show: xAxis.length > 7,
                  borderColor: "transparen", // 边框颜色
                  handleSize: 10, // 手柄大小
                  zoomLock: true, // 缩放锁定
                  showDetail: false, // 不显示详细信息
                  showDataShadow: false,
                  brushSelect: false,
                  handleStyle: {
                    opacity: 0.3,
                  },
                  backgroundColor: "#eee",
                  fillerColor: "#0090FF ",
                },
              ],
              series: [
                {
                  data: workDoneNum,
                  type: "bar",
                  stack: "total",
                  name: "已完成",
                  barWidth: 14,
                  barGap: 20,
                  itemStyle: {
                    color: "#00B9EE",
                    barBorderRadius: this.doingNum > 0 ? [0, 0, 10, 10] : [10],
                  },
                  emphasis: {
                    itemStyle: {
                      color: "#00B9EE",
                    },
                  },
                },
                {
                  data: workDoingNum,
                  type: "bar",
                  stack: "total",
                  name: "未完成",
                  barWidth: 14,
                  barGap: 20,
                  itemStyle: {
                    color: "#EEEEEE",
                    barBorderRadius: this.doneNum > 0 ? [10, 10, 0, 0] : [10],
                  },
                  emphasis: {
                    itemStyle: {
                      color: "#EEEEEE",
                    },
                  },
                },
              ],
            };
            workOrder.setOption(option1);
            issues.setOption(option2);
            issues.getZr().off("click");
            if (this.projectId === "") {
              issues.getZr().on("click", (params) => {
                const pointInPixel = [params.offsetX, params.offsetY];
                if (issues.containPixel("grid", pointInPixel)) {
                  let yIndex = issues.convertFromPixel({ seriesIndex: 0 }, [
                    params.offsetX,
                    params.offsetY,
                  ])[0];
                  const xValue = xAxis[yIndex];
                  issues.dispatchAction({ type: "hideTip" });
                  const startTime = this.searchdate[0]
                    ? this.searchdate[0]
                    : "";
                  const endTime = this.searchdate[1] ? this.searchdate[1] : "";
                  this.projectId = this.projectList.filter(
                    (item) => item.projectName === xValue
                  )[0].projectId;
                  this.$router.push({
                    name: "processworkorder",
                    query: { startTime, endTime, projectId: this.projectId },
                  });
                }
              });
            } else {
              issues.getZr().on("click", () => {
                issues.dispatchAction({ type: "hideTip" });
                this.Toprocessworkorder();
              });
            }
          });
        });
    },
    Toprocessworkorder() {
      this.$disposeCharts()
      const projectId = this.projectId || "";
      const startTime = this.searchdate[0] ? this.searchdate[0] : "";
      const endTime = this.searchdate[1] ? this.searchdate[1] : "";
      this.$router.push({
        name: "processworkorder",
        query: {
          projectId,
          startTime,
          endTime,
        },
      });
    },
    // 获取品质监管
    changeTabs(val) {
      this.Tabs = val;
      if (val === "0") {
        if (this.issuesBar) {
          this.issuesBar.clear();
          this.issuesBar = null;
        }
        this.getTaskBar();
      } else {
        this.showTask = false;
        this.getIssuesBar();
      }
    },
    getTaskBar() {
      this.$axios
        .get(this.$apis.patrol.selectTaskSumV2, {
          projectId: this.projectId,
          startTime: this.searchdate[0] ? this.searchdate[0] : "",
          endTime: this.searchdate[1] ? this.searchdate[1] : "",
        })
        .then((res) => {
          this.taskCount = res.taskCount; // 巡查任务数量
          this.ywcTaskCount = res.ywcTaskCount; // 已完成巡查任务
          this.wwcTaskCount = res.taskCount - res.ywcTaskCount; // 未完成巡查任务

          if (this.Tabs === "0") {
            this.$nextTick(() => {
              const taskBar = this.$getChartInstance("#taskBar");
              if (!taskBar) return;
              const xAxis = res.list.map((item) => {
                return item.x;
              });
              const ywcData = res.list.map((item) => {
                return item.ywcTaskCount;
              });
              const wwcData = res.list.map((item) => {
                return item.taskCount - item.ywcTaskCount;
              });

              if (
                xAxis.length === 0 &&
                ywcData.length === 0 &&
                wwcData.length === 0
              ) {
                taskBar.clear();
                this.showTask = true;
                return;
              }
              this.showTask = false;
              const option = {
                legend: {
                  data: ["已完成", "未完成"],
                  right: 15,
                  top: 20,
                  itemWidth: 12,
                  itemHeight: 12,
                  textStyle: {
                    fontSize: 12,
                    color: "#333",
                  },
                },
                grid: {
                  left: 10,
                  top: 60,
                  right: 14,
                  bottom: 13,
                  containLabel: true,
                },
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "shadow",
                  },
                },
                xAxis: {
                  type: "category",
                  data: xAxis,
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: false,
                  },
                  axisLabel: {
                    overflow: "truncate",
                    ellipsis: "...",
                    color: "#809FB8",
                    fontSize: 12,
                    fontFamily: "PingFangSC, PingFang SC",
                    fontWeight: "400",
                    fontStyle: "normal",
                    textTransform: "none",
                    formatter: function (value) {
                      if (value.length > 5) {
                        return value.slice(0, 4);
                      } else {
                        return value;
                      }
                    },
                  },
                },
                yAxis: {
                  type: "value",
                  axisLabel: {
                    show: false,
                  },
                },
                dataZoom: [
                  {
                    type: "slider", // 内置缩放
                    xAxisIndex: [0],
                    start: 0, // 初始缩放比例
                    end: xAxis.length > 5 ? 20 : 100, // 结束缩放比例
                    filterMode: "empty",
                    height: 5, // 组件高度
                    bottom: 5,
                    show: xAxis.length > 5,
                    borderColor: "transparen", // 边框颜色
                    handleSize: 10, // 手柄大小
                    zoomLock: true, // 缩放锁定
                    showDetail: false, // 不显示详细信息
                    showDataShadow: false,
                    brushSelect: false,
                    handleStyle: {
                      opacity: 0.3,
                    },
                    backgroundColor: "#eee",
                    fillerColor: "#1AD598 ",
                  },
                ],
                series: [
                  {
                    data: ywcData,
                    type: "bar",
                    stack: "total",
                    name: "已完成",
                    itemStyle: {
                      color: "#1AD598",
                      barBorderRadius:
                        this.taskCount - this.ywcTaskCount > 0
                          ? [0, 0, 10, 10]
                          : [10],
                    },
                    barWidth: 14,
                    barGap: 20,
                    emphasis: {
                      itemStyle: {
                        color: "#1AD598",
                      },
                    },
                  },
                  {
                    data: wwcData,
                    type: "bar",
                    stack: "total",
                    name: "未完成",
                    itemStyle: {
                      color: "#EEEEEE",
                      barBorderRadius:
                        this.ywcTaskCount > 0 ? [10, 10, 0, 0] : [10],
                    },
                    barWidth: 14,
                    barGap: 20,
                    emphasis: {
                      itemStyle: {
                        color: "#EEEEEE",
                      },
                    },
                  },
                ],
              };
              taskBar.setOption(option);
              taskBar.getZr().off("click");
              if (this.projectId === "") {
                taskBar.getZr().on("click", (params) => {
                  const pointInPixel = [params.offsetX, params.offsetY];
                  if (taskBar.containPixel("grid", pointInPixel)) {
                    let yIndex = taskBar.convertFromPixel({ seriesIndex: 0 }, [
                      params.offsetX,
                      params.offsetY,
                    ])[0];
                    const xValue = xAxis[yIndex]; //x轴的值
                    taskBar.dispatchAction({ type: "hideTip" });
                    const startTime = this.searchdate[0]
                      ? this.searchdate[0]
                      : "";
                    const endTime = this.searchdate[1]
                      ? this.searchdate[1]
                      : "";
                    this.projectId = this.projectList.filter(
                      (item) => item.projectName === xValue
                    )[0].projectId;
                    this.$router.push({
                      name: "patrolTaskList",
                      query: { startTime, endTime, projectId: this.projectId },
                    });
                  }
                });
              } else {
                taskBar.getZr().on("click", () => {
                  taskBar.dispatchAction({ type: "hideTip" });
                  this.TopatrolTaskList();
                });
              }
            });
          }
        });
    },
    TopatrolTaskList() {
      this.$disposeCharts()
      const projectId = this.projectId || "";
      this.$router.push({
        name: "patrolTaskList",
        query: {
          projectId,
        },
      });
    },
    getIssuesBar() {
      this.$axios
        .get(this.$apis.patrol.selectIssueSumV2, {
          projectId: this.projectId,
          startTime: this.searchdate[0] ? this.searchdate[0] : "",
          endTime: this.searchdate[1] ? this.searchdate[1] : "",
        })
        .then((res) => {
          this.issueCount = res.issueCount; // 巡查问题数量
          this.yclIssueCount = res.yclIssueCount; // 已处理巡查问题
          this.dclIssueCount = res.dclIssueCount; // 未处理巡查问题
          if (this.Tabs === "1") {
            this.$nextTick(() => {
              this.issuesBar = this.$getChartInstance("#issuesBar");
              if (!this.issuesBar) return;
              const xAxis = res.list.map((item) => {
                return item.x;
              });
              const yclData = res.list.map((item) => {
                return item.yclIssueCount;
              });
              const dclData = res.list.map((item) => {
                return item.dclIssueCount;
              });
              const option = {
                legend: {
                  data: ["已完成", "未完成"],
                  right: 15,
                  top: 20,
                  itemWidth: 12,
                  itemHeight: 12,
                  textStyle: {
                    fontSize: 12,
                    color: "#333",
                  },
                },
                grid: {
                  left: 10,
                  top: 60,
                  right: 14,
                  bottom: 13,
                  containLabel: true,
                },
                xAxis: {
                  type: "category",
                  data: xAxis,
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: false,
                  },
                  axisLabel: {
                    overflow: "truncate",
                    ellipsis: "...",
                    color: "#809FB8",
                    fontSize: 12,
                    fontFamily: "PingFangSC, PingFang SC",
                    fontWeight: "400",
                    fontStyle: "normal",
                    textTransform: "none",
                    formatter: function (value) {
                      if (value.length > 5) {
                        return value.slice(0, 4);
                      } else {
                        return value;
                      }
                    },
                  },
                },
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "shadow",
                  },
                },
                yAxis: {
                  type: "value",
                  axisLabel: {
                    show: false,
                  },
                },
                dataZoom: [
                  {
                    type: "slider", // 缩放
                    xAxisIndex: [0],
                    start: 0, // 初始缩放比例
                    end: xAxis.length > 7 ? 20 : 100, // 结束缩放比例
                    filterMode: "empty",
                    height: 5, // 组件高度
                    bottom: 5,
                    show: xAxis.length > 7,
                    borderColor: "transparen", // 边框颜色
                    handleSize: 10, // 手柄大小
                    zoomLock: true, // 缩放锁定
                    showDetail: false, // 不显示详细信息
                    showDataShadow: false,
                    brushSelect: false,
                    handleStyle: {
                      opacity: 0.3,
                    },
                    backgroundColor: "#eee",
                    fillerColor: "#1AD598 ",
                  },
                ],
                series: [
                  {
                    data: yclData,
                    type: "bar",
                    name: "已完成",
                    itemStyle: {
                      color: "#1AD598",
                      barBorderRadius:
                        this.dclIssueCount > 0 ? [0, 0, 10, 10] : [10],
                    },
                    stack: "total",
                    barMaxWidth: 20,
                    barGap: 20,
                    emphasis: {
                      itemStyle: {
                        color: "#1AD598",
                      },
                    },
                  },
                  {
                    data: dclData,
                    type: "bar",
                    name: "未完成",
                    itemStyle: {
                      color: "#EEEEEE",
                      barBorderRadius:
                        this.yclIssueCount > 0 ? [10, 10, 0, 0] : [10],
                    },
                    stack: "total",
                    barMaxWidth: 20,
                    barGap: 20,
                    emphasis: {
                      itemStyle: {
                        color: "#EEEEEE",
                      },
                    },
                  },
                ],
              };
              this.issuesBar.clear();
              this.issuesBar.setOption(option);
              this.issuesBar.getZr().off("click");
              if (this.projectId === "") {
                this.issuesBar.getZr().on("click", (params) => {
                  const pointInPixel = [params.offsetX, params.offsetY];
                  if (this.issuesBar.containPixel("grid", pointInPixel)) {
                    let yIndex = this.issuesBar.convertFromPixel(
                      { seriesIndex: 0 },
                      [params.offsetX, params.offsetY]
                    )[0];
                    const xValue = xAxis[yIndex]; //x轴的值
                    this.issuesBar.dispatchAction({ type: "hideTip" });
                    const startTime = this.searchdate[0]
                      ? this.searchdate[0]
                      : "";
                    const endTime = this.searchdate[1]
                      ? this.searchdate[1]
                      : "";
                    this.projectId = this.projectList.filter(
                      (item) => item.projectName === xValue
                    )[0].projectId;
                    this.$router.push({
                      name: "processinspection",
                      query: { startTime, endTime, projectId: this.projectId },
                    });
                  }
                });
              } else {
                this.issuesBar.getZr().on("click", () => {
                  this.issuesBar.dispatchAction({ type: "hideTip" });
                  this.ToProcessinSpection();
                });
              }
            });
          }
        });
    },
    ToProcessinSpection() {
      this.$disposeCharts()
      const projectId = this.projectId || "";
      const startTime = this.searchdate[0] ? this.searchdate[0] : "";
      const endTime = this.searchdate[1] ? this.searchdate[1] : "";
      this.$router.push({
        name: "processinspection",
        query: {
          projectId,
          startTime,
          endTime,
        },
      });
    },
    // 获取用料管理
    getMaterial() {
      this.$axios
        .get(this.$apis.material.selectYhCheckoutStat, {
          projectId: this.projectId,
          startTime: this.searchdate[0] ? this.searchdate[0] : "",
          endTime: this.searchdate[1] ? this.searchdate[1] : "",
        })
        .then((res) => {
          this.$nextTick(() => {
            const materialNightingale = this.$getChartInstance(
              "#materialNightingale"
            );
            if (!materialNightingale) return;
            let materialData = [];
            if (this.projectId === "") {
              materialData = res.map((item) => {
                return {
                  value: item.materialStockNum,
                  name: item.projectName,
                };
              });
            } else {
              materialData = res.map((item) => {
                return {
                  value: item.materialStockNum,
                  name: item.materialTypeName,
                };
              });
            }
            const option = {
              tooltip: {
                trigger: "item",
                confine: false,
                appendToBody: true,
              },
              series: [
                {
                  type: "pie",
                  radius: ["45%", "60%"],
                  itemStyle: {
                    borderRadius: 5,
                    borderColor: "#fff",
                    borderWidth: 2,
                  },
                  label: {
                    show: true,
                    position: "outside",
                    padding: [5, 5],
                    formatter: (params) => {
                      if (params.name.length > 5) {
                        return params.name.slice(0, 4) + "...";
                      } else {
                        return params.name;
                      }
                    },
                  },
                  // labelLine: {
                  //   show: true,
                  //   length: 1,
                  //   length2: 5
                  // },
                  data: materialData,
                },
              ],
            };
            materialNightingale.setOption(option);
            if (this.projectId === "") {
              materialNightingale.off("click");
              materialNightingale.on("click", (params) => {
                materialNightingale.dispatchAction({ type: "hideTip" });
                const projectName = params.name;
                const startTime = this.searchdate[0] ? this.searchdate[0] : "";
                const endTime = this.searchdate[1] ? this.searchdate[1] : "";
                this.$router.push({
                  path: "/property/materialexwarehouse",
                  query: { projectName, startTime, endTime },
                });
              });
            } else {
              materialNightingale.getZr().off("click");
              materialNightingale.getZr().on("click", () => {
                materialNightingale.dispatchAction({ type: "hideTip" });
                this.Tomaterialexwarehouse();
              });
            }
          });
        });
    },
    Tomaterialexwarehouse() {
      this.$disposeCharts()
      const projectName = this.projectId
        ? this.projectList.find((item) => item.projectId === this.projectId)
          .projectName
        : "";
      const startTime = this.searchdate[0] ? this.searchdate[0] : "";
      const endTime = this.searchdate[1] ? this.searchdate[1] : "";
      this.$router.push({
        path: "/property/materialexwarehouse",
        query: { projectName, startTime, endTime },
      });
    },
    // 获取机械管理
    getMachine() {
      let machineData = [];
      this.$axios
        .get(this.$apis.machine.selectYhMachineTeamStat, {
          projectId: this.projectId,
          startTime: this.searchdate[0] ? this.searchdate[0] : "",
          endTime: this.searchdate[1] ? this.searchdate[1] : "",
        })
        .then((res) => {
          this.machineCount = res.machineCount;
          this.machineHour = res.hours;
          this.$nextTick(() => {
            const machinePie = this.$getChartInstance("#machinePie");
            if (!machinePie) return;
            if (this.projectId === "") {
              machineData = res.machineTeamStatLst.map((item) => {
                return {
                  value: item.hours,
                  name: item.projectName,
                };
              });
            } else {
              machineData = res.machineTeamStatLst.map((item) => {
                return {
                  value: item.hours,
                  name: item.machineryName,
                };
              });
            }
            const option = {
              tooltip: {
                trigger: "item",
                confine: false,
                appendToBody: true,
              },
              series: [
                {
                  type: "pie",
                  radius: ["45%", "60%"],
                  itemStyle: {
                    borderRadius: 5,
                    borderColor: "#fff",
                    borderWidth: 3,
                  },
                  label: {
                    show: true,
                    position: "outside",
                    padding: [5, 5],
                    formatter: (params) => {
                      if (params.name.length > 5) {
                        return params.name.slice(0, 4) + "...";
                      } else {
                        return params.name;
                      }
                    },
                  },
                  data: machineData,
                },
              ],
            };
            machinePie.setOption(option);
            if (this.projectId === "") {
              machinePie.off("click");
              machinePie.on("click", (params) => {
                machinePie.dispatchAction({ type: "hideTip" });
                const projectName = params.name;
                const startTime = this.searchdate[0] ? this.searchdate[0] : "";
                const endTime = this.searchdate[1] ? this.searchdate[1] : "";
                this.projectId = this.projectList.filter(
                  (item) => item.projectName === projectName
                )[0].projectId;
                this.$router.push({
                  path: "/laborManageList/taiBanLabor",
                  query: { projectId: this.projectId, startTime, endTime },
                });
              });
            } else {
              machinePie.getZr().off("click");
              machinePie.getZr().on("click", () => {
                machinePie.dispatchAction({ type: "hideTip" });
                this.ToMachineTeam();
              });
            }
          });
        });
    },
    ToMachineTeam() {
      this.$disposeCharts()
      const projectId = this.projectId || "";
      const startTime = this.searchdate[0] ? this.searchdate[0] : "";
      const endTime = this.searchdate[1] ? this.searchdate[1] : "";
      this.$router.push({
        path: "/laborManageList/taiBanLabor",
        query: { projectId, startTime, endTime },
      });
    },
    // 获取智能设备
    showDialog() {
      this.dialogVisible = true;
    },
    getDeviceOnlineTotal() {
      this.$axios
        .get(this.$apis.device.selectDeviceOnlineTotal, {
          projectId: this.projectId,
        })
        .then((res) => {
          this.deviceTotal = res.total;
          this.totalOnline = res.totalOnline;
          this.totalOffline = res.totalOffline;
          this.onlineRate = res.onlineRate;
          this.$nextTick(() => {
            const deviceGauge = this.$getChartInstance("#deviceGauge");
            if (!deviceGauge) return;
            const option = {
              series: [
                {
                  type: "gauge",
                  startAngle: 90,
                  endAngle: -270,
                  center: ["50%", "50%"],
                  radius: "62%",
                  pointer: {
                    show: false,
                  },
                  progress: {
                    show: true,
                    overlap: false,
                    roundCap: true,
                    clip: false,
                  },
                  axisLine: {
                    lineStyle: {
                      width: 12,
                      color: [[1, "#F1F4F9"]],
                    },
                  },
                  splitLine: {
                    show: false,
                    distance: 0,
                    length: 10,
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    show: false,
                    distance: 5,
                  },
                  data: [
                    {
                      value: parseInt(this.onlineRate.replace("%", "")),
                      name: "在线率",
                      title: {
                        offsetCenter: ["-2%", "32%"],
                      },
                      detail: {
                        offsetCenter: ["0%", "-10%"],
                      },
                      itemStyle: {
                        color: "#5855DF",
                      },
                    },
                  ],
                  title: {
                    fontSize: 14,
                    color: "#050708",
                    width: 42,
                    height: 28,
                    lineHeight: 28,
                    fontFamily: "PingFangSC, PingFang SC",
                    fontWeight: "400",
                    fontStyle: "normal",
                    textTransform: "none",
                  },
                  detail: {
                    width: 44,
                    height: 38,
                    lineHeight: 38,
                    fontSize: 20,
                    color: "#050505",
                    fontFamily: "PingFangSC, PingFang SC",
                    fontWeight: "400",
                    fontStyle: "normal",
                    textTransform: "none",
                    formatter: "{value}%",
                  },
                },
              ],
            };
            deviceGauge.setOption(option);
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  height: calc(370 / 930 * 100vh);

  .col {
    height: 100%;

    .patrol {
      width: 100%;
      height: calc(300 / 930 * 100vh);
      padding: 1vw;
      background: #f1f5f7;
      border-radius: 0.52vw;

      .patrol-item {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .patrol-left {
          width: 24%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-around;

          .patrol-left-item {
            width: 100%;
            height: 50%;
            display: flex;
            padding-left: 0.52vw;
            align-items: center;
            justify-content: flex-end;

            &.active {
              background: #ffffff;
              border-radius: 0.52vw 0px 0px 0.52vw;
            }

            .line {
              width: 0.21vw;
              height: 90%;
              background: #f1f5f7;
              border-radius: 0.26vw 0px 0px 26vw;

              &.active {
                background: #4a90e2;
              }
            }

            .patrol-left-item-d {
              width: 100%;
              height: 90%;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-around;

              .patrol-left-item-s1 {
                height: calc(24 / 930 * 100vh);
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 0.83vw;
                color: #000000;
                line-height: calc(24 / 930 * 100vh);
                text-align: left;
                font-style: normal;
                padding-left: 0.52vw;
              }

              .patrol-left-item-s2 {
                height: calc(34 / 930 * 100vh);
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 1.35vw;
                color: #000000;
                line-height: calc(34 / 930 * 100vh);
                text-align: left;
                font-style: normal;
                padding-left: 0.52vw;
              }

              .patrol-left-item-s3 {
                height: calc(24 / 930 * 100vh);
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 0.83vw;
                color: #000000;
                line-height: calc(24 / 930 * 100vh);
                text-align: left;
                font-style: normal;
                padding-left: 0.52vw;
              }
            }
          }
        }

        .patrol-right {
          width: 76%;
          height: 100%;
          display: flex;
          background: #fff;
          border-radius: 0px 0.52vw 0.52vw 0px;

          &.show {
            width: 0px;
          }
        }

        .patrol-right1 {
          width: 76%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #fff;
          border-radius: 0px 0.52vw 0.52vw 0px;

          ::v-deep div:has(canvas) {
            width: 0px !important;
          }
        }

        ::v-deep .patrol-right1>div:first-child {
          width: 0px !important;
        }
      }
    }

    .endance {
      width: 100%;
      height: calc(300 / 930 * 100vh);
      display: flex;
      justify-content: space-around;

      .endance-item {
        width: 28%;
        height: calc(280 / 930 * 100vh);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        .endance-item-top {
          width: 100%;
          height: calc(90 / 930 * 100vh);
          display: flex;
          margin: 0.52vw 0 0 0.52vw;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-around;

          .top-s1 {
            width: 100%;
            height: calc(24 / 930 * 100vh);
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.83vw;
            color: #000000;
            line-height: calc(24 / 930 * 100vh);
            text-align: left;
            font-style: normal;
          }

          .top-item {
            width: 100%;
            height: calc(34 / 930 * 100vh);
            display: flex;
            align-items: last baseline;
            white-space: nowrap;

            .top-s2 {
              height: calc(34 / 930 * 100vh);
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 1.35vw;
              color: #000000;
              line-height: calc(34 / 930 * 100vh);
              text-align: left;
              font-style: normal;
              display: inline-block;
            }

            .top-s3 {
              height: calc(32 / 930 * 100vh);
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.63vw;
              color: #354052;
              line-height: calc(32 / 930 * 100vh);
              text-align: left;
              font-style: normal;
              display: inline-block;
              margin-left: 0.26vw;
            }
          }
        }

        .endance-item-bottom {
          width: 100%;
          height: calc(120 / 930 * 100vh);
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          .bottom-item {
            width: 100%;
            height: calc(50 / 930 * 100vh);
            display: flex;
            align-items: flex-start;
            justify-content: space-around;

            .item-img {
              width: 2.08vw;
              height: 2.08vw;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(163, 202, 255, 0.3);
              border-radius: 50%;
              margin-top: 0.3vw;

              .item-img-i {
                width: 1.77vw;
                height: 1.77vw;
                background: rgba(33, 126, 253, 0.3);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              i {
                font-size: 1.04vw;
                color: #217efd;
              }

              .i2 {
                color: #15b47f;
                margin: 0.21vw 0 0 -0.78vw;
              }
            }

            .item-1 {
              width: 60%;
              height: calc(50 / 930 * 100vh);
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-around;

              .endance-s1 {
                width: 100%;
                height: calc(24 / 930 * 100vh);
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 0.83vw;
                color: #809fb8;
                line-height: calc(24 / 930 * 100vh);
                text-align: left;
                font-style: normal;
                text-transform: none;
              }

              .item-2 {
                width: 100%;
                display: flex;
                align-items: last baseline;
                white-space: nowrap;

                .endance-s2 {
                  height: calc(24 / 930 * 100vh);
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 0.83vw;
                  color: #000000;
                  line-height: calc(24 / 930 * 100vh);
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: inline-block;
                }

                .endance-s3 {
                  height: 1.04vw;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 0.63vw;
                  color: #000000;
                  line-height: 1.04vw;
                  text-align: left;
                  font-style: normal;
                  display: inline-block;
                  margin-left: 0.26vw;
                }
              }
            }
          }
        }
      }

      .endance-content {
        width: 70%;
        margin-top: 0.52vw;
        height: calc(280 / 930 * 100vh);
      }
    }

    .task {
      width: 100%;
      height: calc(300 / 930 * 100vh);
      display: flex;
      justify-content: center;

      .issues-content {
        width: 68%;
        height: 100%;
      }

      .task-content {
        width: 30%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .task-pie {
          width: 100%;
          height: 50%;
        }

        .task-item {
          width: 100%;
          height: calc(130 / 930 * 100vh);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 0.52vw;

          .task-top {
            width: 64%;
            height: calc(120 / 930 * 100vh);
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: calc(15 / 930 * 100vh);
            // text-align: right;
            justify-content: space-around;

            .task-s1 {
              width: 88%;
              height: calc(24 / 930 * 100vh);
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.83vw;
              color: #000000;
              line-height: calc(24 / 930 * 100vh);
              text-align-last: justify;
              font-style: normal;
            }
          }

          .task-bottom {
            width: 35%;
            height: calc(120 / 930 * 100vh);
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: calc(15 / 930 * 100vh);
            text-align: left;
            justify-content: space-around;

            .task-s2 {
              height: calc(24 / 930 * 100vh);
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.73vw;
              color: #000000;
              line-height: calc(24 / 930 * 100vh);
              text-align: left;
              font-style: normal;
            }
          }
        }
      }
    }

    .el-card {
      height: calc(370 / 930 * 100vh);
      border-radius: 0.42vw;

      ::v-deep .el-card__body {
        height: calc(310 / 930 * 100vh);
        padding: 0.52vw;
      }

      ::v-deep .el-card__header {
        height: calc(48 / 930 * 100vh);
        padding: 0.63vw 0.83vw;
        border-bottom: 1px solid #e8e8e8;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 0.94vw;
        color: #333333;
        text-align: left;
        font-style: normal;
      }

      .grid-content {
        height: calc(280 / 930 * 100vh);
        background-color: #ffffff;
        border-radius: 0.42vw;
      }
    }

    .dailyreport-content {
      width: 100%;
      height: calc(300 / 930 * 100vh);
    }

    .machine-content {
      height: calc(230 / 930 * 100vh);
      width: 100%;
    }

    .material-content {
      height: calc(280 / 930 * 100vh);
      width: 100%;
    }

    .machineMage {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 0.52vw;

      .machineMage-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .machineMage-item-s1 {
          height: calc(24 / 930 * 100vh);
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.83vw;
          color: #7f8fa4;
          line-height: calc(24 / 930 * 100vh);
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .machineMage-item-s2 {
          height: calc(24 / 930 * 100vh);
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 1.04vw;
          color: #000000;
          line-height: calc(24 / 930 * 100vh);
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }

    .item {
      height: calc(280 / 930 * 100vh);
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }

    .device-content {
      height: calc(230 / 930 * 100vh);
      width: 100%;
    }

    .devicecount {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0.52vw;

      .devicecount-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .devicecount-item-s1 {
          height: calc(24 / 930 * 100vh);
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.83vw;
          color: #7f8fa4;
          line-height: calc(24 / 930 * 100vh);
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .devicecount-item-s2 {
          height: calc(24 / 930 * 100vh);
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 1.04vw;
          color: #000000;
          line-height: calc(24 / 930 * 100vh);
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .row .col {
    .el-card {
      ::v-deep .el-card__header {
        font-size: 0.83vw; // 小屏幕适当放大字号
      }
    }
  }
}
</style>
